var React = require('react');

function Lock (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_573","data-name":"Path 573","d":"M281.43,1726.894v-11.367a23.082,23.082,0,0,0-23.083-23.083h0a23.083,23.083,0,0,0-23.083,23.083v11.367a6.782,6.782,0,0,0-5.448,6.648v28.25a9.935,9.935,0,0,0,9.935,9.935h37.192a9.935,9.935,0,0,0,9.935-9.935v-28.25A6.781,6.781,0,0,0,281.43,1726.894Zm-20.2,23.027v5.41a2.887,2.887,0,0,1-5.774,0v-5.41a5.108,5.108,0,1,1,5.774,0Zm11.312-23.159h-28.4v-11.235a14.2,14.2,0,0,1,28.4,0Z","transform":"translate(-229.816 -1692.444)","fill":"#606060"}));
}

Lock.defaultProps = {"width":"50px","height":"50px","viewBox":"0 0 57.062 79.283"};

module.exports = Lock;

Lock.default = Lock;
